import { render } from "./standarPelayanan.vue?vue&type=template&id=eb0669f0"
import script from "./standarPelayanan.vue?vue&type=script&lang=js"
export * from "./standarPelayanan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__